import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {RiInstagramLine} from 'react-icons/ri'
import {BsWhatsapp} from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from 'emailjs-com'


const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        console.log("haiii");
        e.preventDefault();
        emailjs.sendForm('service_4iigahq', 'template_zozorbk', form.current, 'BkhE4jSfVdwvex2L1')
        e.target.reset();
        alert("Thank you for reaching out! Your message has been successfully sent. I'll get back to you as soon as possible.");
    };
    return (
        <section id='contact'>
            <h5>Get In Touch</h5>
            <h2>Contact Me</h2>
            <div className="container contact__container">
                <div className="contact__options">
                    <article className="contact__option">
                        <MdOutlineEmail className='contact__option-icon'/>
                        <h4>Email</h4>
                        <h5>cheming@ualberta.ca</h5>
                        <a href="mailto:cheming@ualberta.ca" target='_blank' rel="noreferrer">Send a message</a>
                    </article>
                    <article className="contact__option">
                        <RiInstagramLine className='contact__option-icon'/>
                        <h4>Instagram</h4>
                        <h5>Jimmy Chung</h5>
                        <a href="https://www.instagram.com/m/imi.___._/" target='_blank' rel="noreferrer">Send a message</a>
                    </article>
                    <article className="contact__option">
                        <BsWhatsapp className='contact__option-icon'/>
                        <h4>Phone</h4>
                        <h5>+1 778-548-9600</h5>
                        <a href="https://wa.me/17785489600" target='_blank' rel="noreferrer">Send a message</a>
                    </article>
                </div>
                <form ref={form} onSubmit={sendEmail}>
                    <input type="text" name='name' placeholder="Your Full Name" required/>
                    <input type="email" name='email' placeholder='Your Email' required/>
                    <textarea name="message" rows="7" placeholder="Your Message" required></textarea>
                    <button type='submit' className='btn btn-primary'>Send Message</button>
                </form>
            </div>
        </section>
    )
}

export default Contact